const features = [
  { icon: 'ri-folder-open-line', text: 'Gestão completa de processos' },
  { icon: 'ri-calculator-line', text: 'Organização de cálculos' },
  { icon: 'ri-task-line', text: 'Controle de demandas trabalhistas' },
  { icon: 'ri-brain-line', text: 'Integração nativa com a IA' },
  { icon: 'ri-line-chart-line', text: 'Aumento de produtividade' },
  { icon: 'ri-database-2-line', text: 'Centralização das informações' },
];

export default function Plataforma() {
  return (
    <section id="plataforma" className="py-24 md:py-32 relative overflow-hidden" style={{ background: 'linear-gradient(135deg, #0c1a2e 0%, #0f2744 50%, #0c1a2e 100%)' }}>
      {/* Decorative glow */}
      <div className="absolute top-0 right-0 w-96 h-96 rounded-full opacity-10" style={{ background: 'radial-gradient(circle, #38bdf8 0%, transparent 70%)', transform: 'translate(30%, -30%)' }}></div>
      <div className="absolute bottom-0 left-0 w-80 h-80 rounded-full opacity-10" style={{ background: 'radial-gradient(circle, #38bdf8 0%, transparent 70%)', transform: 'translate(-30%, 30%)' }}></div>

      <div className="max-w-7xl mx-auto px-6 md:px-10 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <div>
            <span className="inline-block text-xs font-bold tracking-widest uppercase text-sky-400 mb-4">Plataforma de Gestão</span>
            <h2 className="text-3xl md:text-4xl font-bold text-white leading-tight mb-6">
              Uma solução completa para a rotina do advogado trabalhista
            </h2>
            <p className="text-white/60 text-base leading-relaxed mb-8">
              Nossa plataforma centraliza toda a gestão de processos e cálculos em um único ambiente, integrado à IA da Exato Cálculos. Otimize sua rotina, reduza erros e aumente a produtividade do seu escritório.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
              {features.map((f) => (
                <div key={f.text} className="flex items-center gap-3">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-sky-400/10 border border-sky-400/20 shrink-0">
                    <i className={`${f.icon} text-sky-400 text-base`}></i>
                  </div>
                  <span className="text-sm text-white/70">{f.text}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="#contato"
                onClick={(e) => { e.preventDefault(); document.getElementById('contato')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="px-7 py-3.5 rounded-xl text-white font-semibold text-sm cursor-pointer whitespace-nowrap transition-all duration-200 hover:-translate-y-0.5 text-center"
                style={{ background: 'linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)' }}
              >
                <span className="inline-flex items-center gap-2">
                  <i className="ri-computer-line"></i>
                  Solicitar demonstração
                </span>
              </a>
              <a
                href="#contato"
                onClick={(e) => { e.preventDefault(); document.getElementById('contato')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="px-7 py-3.5 rounded-xl text-white/80 font-semibold text-sm cursor-pointer whitespace-nowrap border border-white/20 hover:bg-white/10 transition-all duration-200 text-center"
              >
                Falar com o time
              </a>
            </div>
          </div>

          {/* Visual */}
          <div className="relative">
            <div className="rounded-3xl overflow-hidden w-full h-[420px] border border-white/10">
              <img
                src="https://readdy.ai/api/search-image?query=modern%20legal%20software%20dashboard%20interface%20on%20laptop%20screen%2C%20dark%20theme%20UI%20with%20blue%20accents%2C%20data%20charts%20and%20workflow%20management%2C%20professional%20technology%20workspace%2C%20clean%20minimal%20design%2C%20dark%20background%20with%20glowing%20elements%2C%20no%20people%2C%20high%20quality%20product%20photography&width=700&height=420&seq=plat001&orientation=landscape"
                alt="Plataforma Exato"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
            </div>

            {/* Floating badge */}
            <div className="absolute top-6 left-6 bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl px-5 py-3">
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse"></span>
                <span className="text-white text-xs font-semibold">Sistema Online</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
